import { useToastContext } from "components/alert/ToastContext";
import { Label } from "components/input/Label";
import DocumentoVersao from "model/documentos/DocumentoVersao";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";
import { useLoadingContext } from "provider/LoadingProvider";
import { useEffect, useState } from "react";
import DocumentoVersaoService from "service/documentos/DocumentoVersaoService";
import FirebasePdfService from "service/FirabasePdfService";

type Props = {
    visible: boolean;
    onHide: () => void;
    documentoVersao: DocumentoVersao | null;
    url: string;
}

const documentoVersaoService = new DocumentoVersaoService();
const firebasePdfService = new FirebasePdfService();
export default function ModalDocumentoVisualizar(props: Props) {
    const [temConfirmacaoLeitura, setTemConfirmacaoLeitura] = useState(false);
    const { msgAlerta, msgErro, msgSucesso } = useToastContext();
    const { startLoading, stopLoading } = useLoadingContext();

    useEffect(() => {
        if (props.visible && props.documentoVersao) {
            documentoVersaoService.temConfirmacaoLeitura(props.documentoVersao.id).then((data) => {
                setTemConfirmacaoLeitura(!!data);
            });
        }
    }, [props.visible, props.documentoVersao])


    const handleConfirmarLeitura = () => {
        confirmDialog({
            message: 'Tem certeza que deseja Confirmar a leitura?',
            header: 'Confirmação',
            icon: 'pi pi-exclamation-triangle',
            acceptLabel: "Sim",
            rejectLabel: "Não",
            accept: () => {
                if (props.documentoVersao) {
                    confirmarLeitura(props.documentoVersao)
                }
            }
        });
    }

    const confirmarLeitura = (documentoVersao: DocumentoVersao) => {
        startLoading()
        documentoVersaoService.confirmarLeitura(documentoVersao).then(() => {
            msgSucesso("Confirmar Leitura", "Leitura confirmada com sucesso")
        }).catch((error) => {
            console.error(error);
            if (error && error.data && error.data.message) {
                msgErro("Confirmar Leitura", error.data.message);
            } else {
                msgErro("Confirmar Leitura", 'Ocorreu um erro ao tentar remover o registro, tente novamente!');
            }
        }).finally(() => {
            stopLoading()
            props.onHide()
        })
    }

    function renderView() {
        if (props.documentoVersao?.arquivo?.imagem) {
            return (
                <div style={{ width: '100%', height: 'auto', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    <img src={props.documentoVersao?.arquivo?.url} alt="Visualização do Documento" style={{ height: "auto", maxHeight: "70vh" }} />
                </div>
            )
        }
        if (props.documentoVersao?.arquivo?.pdf) {
            return <iframe
                src={firebasePdfService.getPdfUrl(props.url)}
                style={{ width: '100%', height: '600px', border: 'none' }}
                title="Visualização do Documento"
            ></iframe>
        }

        return <iframe
            src={`https://docs.google.com/gview?embedded=true&url=${encodeURIComponent(props.url)}`}
            style={{ width: '100%', height: '600px', border: 'none' }}
            title="Visualização do Documento"
        ></iframe>
    }

    return (
        <>
            <Dialog
                header="Visualizar Documento"
                visible={props.visible}
                baseZIndex={100}
                style={{ width: '80%' }}
                onHide={props.onHide}
                footer={<>
                    {props.documentoVersao?.status == "PUBLICADO" && !temConfirmacaoLeitura ? <Button label="Confirmar Leitura" icon="pi pi-eye" onClick={handleConfirmarLeitura} /> : null}
                    <Button label="Fechar" icon="pi pi-times" className="p-button-danger" onClick={props.onHide} />
                </>}
            >
                <div style={{ display: 'flex', flexDirection: 'column', marginBottom: '1rem' }}>
                    <Label>Documento</Label>
                    <div>
                        <span>{props.documentoVersao?.documento?.codigoInterno} - {props.documentoVersao?.documento?.nome}</span>
                    </div>
                    {renderView()}
                </div>

            </Dialog>
        </>
    );
}